// @generated by protoc-gen-es v2.9.0 with parameter "target=ts,import_extension=.js"
// @generated from file finance/v1/invoice_events.proto (package finance.v1, edition 2023)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Invoice, InvoiceStatus } from "./domain_pb.js";
import { file_finance_v1_domain } from "./domain_pb.js";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file finance/v1/invoice_events.proto.
 */
export const file_finance_v1_invoice_events: GenFile = /*@__PURE__*/
  fileDesc("Ch9maW5hbmNlL3YxL2ludm9pY2VfZXZlbnRzLnByb3RvEgpmaW5hbmNlLnYxIpMCCgxJbnZvaWNlRXZlbnQSMgoHY3JlYXRlZBgBIAEoCzIfLmZpbmFuY2UudjEuSW52b2ljZUNyZWF0ZWRFdmVudEgAEjIKB3VwZGF0ZWQYAiABKAsyHy5maW5hbmNlLnYxLkludm9pY2VVcGRhdGVkRXZlbnRIABIyCgdkZWxldGVkGAMgASgLMh8uZmluYW5jZS52MS5JbnZvaWNlRGVsZXRlZEV2ZW50SAASMAoGdm9pZGVkGAQgASgLMh4uZmluYW5jZS52MS5JbnZvaWNlVm9pZGVkRXZlbnRIABIsCgRwYWlkGAUgASgLMhwuZmluYW5jZS52MS5JbnZvaWNlUGFpZEV2ZW50SABCBwoFZXZlbnQiOwoTSW52b2ljZUNyZWF0ZWRFdmVudBIkCgdpbnZvaWNlGAEgASgLMhMuZmluYW5jZS52MS5JbnZvaWNlInIKE0ludm9pY2VVcGRhdGVkRXZlbnQSLQoQcHJldmlvdXNfaW52b2ljZRgBIAEoCzITLmZpbmFuY2UudjEuSW52b2ljZRIsCg91cGRhdGVkX2ludm9pY2UYAiABKAsyEy5maW5hbmNlLnYxLkludm9pY2UiOwoTSW52b2ljZURlbGV0ZWRFdmVudBIkCgdpbnZvaWNlGAEgASgLMhMuZmluYW5jZS52MS5JbnZvaWNlIm4KEkludm9pY2VWb2lkZWRFdmVudBIkCgdpbnZvaWNlGAEgASgLMhMuZmluYW5jZS52MS5JbnZvaWNlEjIKD3ByZXZpb3VzX3N0YXR1cxgCIAEoDjIZLmZpbmFuY2UudjEuSW52b2ljZVN0YXR1cyJsChBJbnZvaWNlUGFpZEV2ZW50EiQKB2ludm9pY2UYASABKAsyEy5maW5hbmNlLnYxLkludm9pY2USMgoPcHJldmlvdXNfc3RhdHVzGAIgASgOMhkuZmluYW5jZS52MS5JbnZvaWNlU3RhdHVzQjNaMXBhY2thZ2VzL2JhY2tlbmQtbW9kdWxlLWZpbmFuY2UvYXBpL3YxO2ZpbmFuY2VfdjFiCGVkaXRpb25zcOgH", [file_finance_v1_domain]);

/**
 * @generated from message finance.v1.InvoiceEvent
 */
export type InvoiceEvent = Message<"finance.v1.InvoiceEvent"> & {
  /**
   * @generated from oneof finance.v1.InvoiceEvent.event
   */
  event: {
    /**
     * @generated from field: finance.v1.InvoiceCreatedEvent created = 1;
     */
    value: InvoiceCreatedEvent;
    case: "created";
  } | {
    /**
     * @generated from field: finance.v1.InvoiceUpdatedEvent updated = 2;
     */
    value: InvoiceUpdatedEvent;
    case: "updated";
  } | {
    /**
     * @generated from field: finance.v1.InvoiceDeletedEvent deleted = 3;
     */
    value: InvoiceDeletedEvent;
    case: "deleted";
  } | {
    /**
     * @generated from field: finance.v1.InvoiceVoidedEvent voided = 4;
     */
    value: InvoiceVoidedEvent;
    case: "voided";
  } | {
    /**
     * @generated from field: finance.v1.InvoicePaidEvent paid = 5;
     */
    value: InvoicePaidEvent;
    case: "paid";
  } | { case: undefined; value?: undefined };
};

/**
 * Describes the message finance.v1.InvoiceEvent.
 * Use `create(InvoiceEventSchema)` to create a new message.
 */
export const InvoiceEventSchema: GenMessage<InvoiceEvent> = /*@__PURE__*/
  messageDesc(file_finance_v1_invoice_events, 0);

/**
 * @generated from message finance.v1.InvoiceCreatedEvent
 */
export type InvoiceCreatedEvent = Message<"finance.v1.InvoiceCreatedEvent"> & {
  /**
   * @generated from field: finance.v1.Invoice invoice = 1;
   */
  invoice?: Invoice;
};

/**
 * Describes the message finance.v1.InvoiceCreatedEvent.
 * Use `create(InvoiceCreatedEventSchema)` to create a new message.
 */
export const InvoiceCreatedEventSchema: GenMessage<InvoiceCreatedEvent> = /*@__PURE__*/
  messageDesc(file_finance_v1_invoice_events, 1);

/**
 * @generated from message finance.v1.InvoiceUpdatedEvent
 */
export type InvoiceUpdatedEvent = Message<"finance.v1.InvoiceUpdatedEvent"> & {
  /**
   * @generated from field: finance.v1.Invoice previous_invoice = 1;
   */
  previousInvoice?: Invoice;

  /**
   * @generated from field: finance.v1.Invoice updated_invoice = 2;
   */
  updatedInvoice?: Invoice;
};

/**
 * Describes the message finance.v1.InvoiceUpdatedEvent.
 * Use `create(InvoiceUpdatedEventSchema)` to create a new message.
 */
export const InvoiceUpdatedEventSchema: GenMessage<InvoiceUpdatedEvent> = /*@__PURE__*/
  messageDesc(file_finance_v1_invoice_events, 2);

/**
 * @generated from message finance.v1.InvoiceDeletedEvent
 */
export type InvoiceDeletedEvent = Message<"finance.v1.InvoiceDeletedEvent"> & {
  /**
   * @generated from field: finance.v1.Invoice invoice = 1;
   */
  invoice?: Invoice;
};

/**
 * Describes the message finance.v1.InvoiceDeletedEvent.
 * Use `create(InvoiceDeletedEventSchema)` to create a new message.
 */
export const InvoiceDeletedEventSchema: GenMessage<InvoiceDeletedEvent> = /*@__PURE__*/
  messageDesc(file_finance_v1_invoice_events, 3);

/**
 * @generated from message finance.v1.InvoiceVoidedEvent
 */
export type InvoiceVoidedEvent = Message<"finance.v1.InvoiceVoidedEvent"> & {
  /**
   * @generated from field: finance.v1.Invoice invoice = 1;
   */
  invoice?: Invoice;

  /**
   * @generated from field: finance.v1.InvoiceStatus previous_status = 2;
   */
  previousStatus: InvoiceStatus;
};

/**
 * Describes the message finance.v1.InvoiceVoidedEvent.
 * Use `create(InvoiceVoidedEventSchema)` to create a new message.
 */
export const InvoiceVoidedEventSchema: GenMessage<InvoiceVoidedEvent> = /*@__PURE__*/
  messageDesc(file_finance_v1_invoice_events, 4);

/**
 * @generated from message finance.v1.InvoicePaidEvent
 */
export type InvoicePaidEvent = Message<"finance.v1.InvoicePaidEvent"> & {
  /**
   * @generated from field: finance.v1.Invoice invoice = 1;
   */
  invoice?: Invoice;

  /**
   * @generated from field: finance.v1.InvoiceStatus previous_status = 2;
   */
  previousStatus: InvoiceStatus;
};

/**
 * Describes the message finance.v1.InvoicePaidEvent.
 * Use `create(InvoicePaidEventSchema)` to create a new message.
 */
export const InvoicePaidEventSchema: GenMessage<InvoicePaidEvent> = /*@__PURE__*/
  messageDesc(file_finance_v1_invoice_events, 5);

